import { render, staticRenderFns } from "./VEmployerEmployeeCompanyDataHistory.vue?vue&type=template&id=4f7fd1f0&lang=pug"
import script from "./VEmployerEmployeeCompanyDataHistory.vue?vue&type=script&lang=ts"
export * from "./VEmployerEmployeeCompanyDataHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports